import { render, staticRenderFns } from "./NftCarousel.vue?vue&type=template&id=1de89a03&scoped=true&"
import script from "./NftCarousel.vue?vue&type=script&lang=js&"
export * from "./NftCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NftCarousel.vue?vue&type=style&index=0&id=1de89a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de89a03",
  null
  
)

export default component.exports